import React, { useState } from "react";
import {
  IconButton,
  Grid,
  Dialog,
  DialogContent,
  DialogTitle,
} from "@mui/material";
import {
  ChevronLeftRounded,
  ChevronRightRounded,
  CloseRounded,
} from "@mui/icons-material";
import { isEmpty } from "lodash";
import {
  formattedAmount,
  formattedAmountWithoutAed,
} from "../../../../utils/CommonFunction";
import { ReactComponent as RightArrowIcon } from "../../../../assets/svg/RightArrowIcon.svg";
import { ReactComponent as SmallDhiramIcon } from "../../../../assets/svg/SmallDhiramIcon.svg";
import { renderCurrencyIcon } from "../../../../utils/CurrencyUtils";

function BudgetCarousel({ details, passedStyles, isMobile }) {
  const [startIndex, setStartIndex] = useState(0);
  const [selectedBudget, setSelectedBudget] = useState(null);

  const handlePrev = () => {
    setStartIndex((prev) => Math.max(prev - 1, 0));
  };

  const handleNext = () => {
    setStartIndex((prev) => Math.min(prev + 1, details?.budget?.length - 2));
  };

  const handleOpenModal = (item) => {
    setSelectedBudget(item);
  };

  const handleCloseModal = () => {
    setSelectedBudget(null);
  };

  return (
    <>
      <div
        style={{
          ...passedStyles.rowFlex,
          justifyContent: "space-between",
          marginRight: "2.5vw",
        }}
      >
        <div style={passedStyles.section_heading}>Budget Items</div>
        {details?.budget?.length > 2 && (
          <div>
            <IconButton onClick={handlePrev} disabled={startIndex === 0}>
              <ChevronLeftRounded />
            </IconButton>
            <IconButton
              onClick={handleNext}
              disabled={startIndex >= details?.budget?.length - 2}
            >
              <ChevronRightRounded />
            </IconButton>
          </div>
        )}
      </div>

      <div
        style={{
          display: "flex",
          overflowX: "auto",
          gap: "20px",
          paddingBottom: "10px",
          scrollbarWidth: "none",
          scrollbarColor: "#D7D8D9 transparent",
          overflowX: "hidden",
        }}
      >
        {details?.budget?.slice(startIndex, startIndex + 2).map((item) => (
          <Grid
            item
            key={item.id}
            onClick={() => handleOpenModal(item)}
            style={{
              flex: "0 0 45%",
              borderRadius: "12px",
              border: "1px solid #D7D8D9",
              minWidth: "280px",
              maxWidth: "500px",
              cursor: "pointer",
            }}
          >
            <div>
              <img
                src={
                  !isEmpty(item?.buget_image)
                    ? item?.buget_image[0]?.image
                    : "https://renohome.blob.core.windows.net/reno-cms/e56d3d53-e335-425f-990e-16e6b2bbee1b"
                }
                alt={`Image ${item.id}`}
                style={{
                  width: "100%",
                  height: isMobile ? "150px" : "200px",
                  objectFit: "cover",
                  borderTopRightRadius: "8px",
                  borderTopLeftRadius: "8px",
                }}
              />
            </div>
            <div
              style={{
                ...passedStyles.columnFlex,
                gap: isMobile ? "5px" : "10px",
                padding: isMobile ? "2vh 4vw" : "2vh 1vw",
              }}
            >
              <div
                style={{
                  ...passedStyles.rowFlex,
                  justifyContent: "space-between",
                }}
              >
                <h3 style={{...passedStyles.budget_item_heading, fontSize: isMobile && "14px"}}>{item?.name}</h3>
               {!isMobile &&  <RightArrowIcon />}
              </div>

              <p style={passedStyles.budget_item_text}>{item?.specification}</p>
              <div style={passedStyles.budget_item_amount_div}>
                <p style={{ color: "#949DAA", fontSize : isMobile && "14px" }}>Amount:</p>
                <p style={{ fontSize : isMobile && "14px" }}>{formattedAmount(item?.total_item)}</p>
              </div>
            </div>
          </Grid>
        ))}
      </div>

      <Dialog
        open={!!selectedBudget}
        onClose={handleCloseModal}
        maxWidth="sm"
        fullWidth
        sx={{
          "& .MuiPaper-root": {
            borderRadius: "12px",
          },
        }}
      >
        {selectedBudget && (
          <>
            <DialogTitle
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                padding: "0",
                position: "relative",
              }}
            >
              <img
                src={
                  !isEmpty(selectedBudget?.buget_image)
                    ? selectedBudget?.buget_image[0]?.image
                    : "https://renohome.blob.core.windows.net/reno-cms/e56d3d53-e335-425f-990e-16e6b2bbee1b"
                }
                alt="Budget Detail"
                style={{
                  width: "100%",
                  height: isMobile ? "180px" : "250px",
                  objectFit: "cover",
                }}
              />
              <IconButton
                onClick={handleCloseModal}
                style={{ position: "absolute", top: 5, right: 5 }}
              >
                <CloseRounded />
              </IconButton>
            </DialogTitle>
            <DialogContent
              style={{
                ...passedStyles.columnFlex,
                ...passedStyles.container,
                gap: "25px",
                padding: isMobile ? "2vh 4vw" : "4vh 2vw",
              }}
            >
              <div style={{ ...passedStyles.columnFlex }}>
                <h2 style={passedStyles.modal_heading}>
                  {selectedBudget?.name}
                </h2>
                <p style={passedStyles.modal_desc}>
                  {selectedBudget?.specification}
                </p>
              </div>
              <div style={{ ...passedStyles.columnFlex, gap: "15px" }}>
                <div style={passedStyles.section_heading}>Specs</div>
                <div style={{ ...passedStyles.columnFlex, gap: "15px" }}>
                  <div
                    style={{
                      ...passedStyles.rowFlex,
                      justifyContent: "space-between",
                    }}
                  >
                    <p style={passedStyles.modal_desc}>Material Type</p>
                    <p style={passedStyles.modal_value}>
                      {selectedBudget?.material_type || "-"}
                    </p>
                  </div>

                  <div
                    style={{
                      ...passedStyles.rowFlex,
                      justifyContent: "space-between",
                    }}
                  >
                    <p style={passedStyles.modal_desc}>Material Unit</p>
                    <p style={passedStyles.modal_value}>
                      {selectedBudget?.material_unit || "-"}
                    </p>
                  </div>
                </div>
              </div>{" "}
              <div style={{ ...passedStyles.columnFlex, gap: "15px" }}>
                <div style={passedStyles.section_heading}>Quantity</div>
                <div style={{ ...passedStyles.columnFlex, gap: "15px" }}>
                  <div
                    style={{
                      ...passedStyles.rowFlex,
                      justifyContent: "space-between",
                    }}
                  >
                    <p style={passedStyles.modal_desc}>Unit Cost</p>
                    <p style={passedStyles.modal_value}>
                      {selectedBudget?.material_unit_price ? (
                        <span
                          style={{
                            display: "flex",
                            flexDirection: "row",
                            alignItems: "center",
                            gap: "5px",
                          }}
                        >
                          {renderCurrencyIcon('small')}
                          {formattedAmountWithoutAed(
                            selectedBudget?.material_unit_price
                          )}
                        </span>
                      ) : (
                        "-"
                      )}
                    </p>
                  </div>
                  <div
                    style={{
                      ...passedStyles.rowFlex,
                      justifyContent: "space-between",
                    }}
                  >
                    <p style={passedStyles.modal_desc}>Quantity</p>
                    <p style={passedStyles.modal_value}>
                      {selectedBudget?.qty || "-"}
                    </p>
                  </div>
                  <div
                    style={{
                      ...passedStyles.rowFlex,
                      justifyContent: "space-between",
                    }}
                  >
                    <p style={passedStyles.modal_desc}>Manpower Rate</p>
                    <p style={passedStyles.modal_value}>
                      {selectedBudget?.manpower_rate || "-"}
                    </p>
                  </div>
                  <div
                    style={{
                      ...passedStyles.rowFlex,
                      justifyContent: "space-between",
                    }}
                  >
                    <p style={passedStyles.modal_desc}>Days</p>
                    <p style={passedStyles.modal_value}>
                      {selectedBudget?.days || "-"}
                    </p>
                  </div>
                </div>
              </div>
            </DialogContent>
          </>
        )}
      </Dialog>
    </>
  );
}

export default BudgetCarousel;
